import { render, staticRenderFns } from "./map-sidebar.vue?vue&type=template&id=0f451c68&scoped=true"
import script from "./map-sidebar.vue?vue&type=script&lang=ts"
export * from "./map-sidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f451c68",
  null
  
)

export default component.exports